import { Observable, of, switchMap } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BaseDatasource } from './base.datasource';
import { SessionRow, SessionsProvider } from '../../sessions/providers/sessions-provider';
import { Organization } from "../models/organization";
import { Paginator } from "../models/paginator";
import { User } from "../models/user";

export class SessionDatasource extends BaseDatasource<SessionRow> {
    constructor(
        private sessionsProvider: SessionsProvider
    ) {
        super();
    }

    private _makeRows({organization, libraryId, user, page, itemsPerPage, search, filter} :
                        {organization: Organization, libraryId: number, user: User | null, page: number, itemsPerPage: number, search: string, filter?: string | null}) : Observable<void> {
        this.loadingSubject.next(true);
        let getRows = this.sessionsProvider.findAllByLibraryPaginated(libraryId, page, itemsPerPage, search, filter);

        if (user !== null) {
            getRows = this.sessionsProvider.findAllByLibraryByUserPaginated(libraryId, page, itemsPerPage, search);
        }

        return getRows.pipe(
          switchMap((paginator: Paginator) => {
            return this.sessionsProvider.getSessionRowsFromSessions(organization, paginator.data, false).pipe(
              map((sessionRows: SessionRow[]) => {
                paginator.data = sessionRows;

                this.totalItems = paginator.total;
                this.itemsPerPage = paginator.per_page;
                this.subject.next(paginator.data);
              }),
              catchError(() => of()),
              finalize(() => this.loadingSubject.next(false))
            );
          }),
        );
    }


    public loadSessionRows(libraryId: number, organization: Organization, page = 1, itemsPerPage: number = environment.itemsPerPage, keyword = '', filter?: string | null): Observable<void> {
      return this._makeRows({organization, libraryId, user: null, page, itemsPerPage, search: keyword, filter});
    }

    public loadSessionRowsByUser(libraryId: number, organization: Organization, user: User, page = 1, itemsPerPage: number = environment.itemsPerPage, keyword = ''): Observable<void> {
        return this._makeRows({organization, libraryId, user, page, itemsPerPage, search: keyword});
    }
}
